import { InventoryTypePlaceholderPage } from "../inventory-placeholder";

export const TissueBlocksPage = () => {
  return <InventoryTypePlaceholderPage title="Tissue Blocks" />;
};
